import { render, staticRenderFns } from "./SubmittedForms.vue?vue&type=template&id=6cd04af4&"
import script from "./SubmittedForms.vue?vue&type=script&lang=ts&"
export * from "./SubmittedForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports